import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { getResetByTag, utilityStyles } from './../../../styles';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1rn7udz",
  styles: "display:flex;white-space:nowrap;align-items:end"
} : {
  name: "1glcjzq-defaultStyles",
  styles: "display:flex;white-space:nowrap;align-items:end;label:defaultStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var defaultStyles = function defaultStyles(_ref2) {
  var align = _ref2.align,
    noWrap = _ref2.noWrap;
  if (noWrap === true) {
    return _ref;
  } else {
    return /*#__PURE__*/css("display:flex;flex-wrap:wrap;align-items:end;justify-content:", align === 'center' ? 'center' : 'end', ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
  }
};
var resetStyles = getResetByTag('span');
var StyledPriceWrapper = /*#__PURE__*/_styled('span', process.env.NODE_ENV === "production" ? {
  target: "e1s012qr0"
} : {
  target: "e1s012qr0",
  label: "StyledPriceWrapper"
})(resetStyles, defaultStyles, utilityStyles);
export default StyledPriceWrapper;